"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const HTTPService_1 = require("../../../../services/HttpService/HTTPService");
const message_utils_1 = __importDefault(require("../../../../utils/message_utils"));
const ServicesWrapper_1 = __importDefault(require("../servicesWrapper/ServicesWrapper"));
const listAssignment_1 = require("../useCases/listAssignment");
require("./MaintenanceList.scss");
const columns = [
    {
        title: 'Código do serviço',
        dataIndex: 'code',
        key: 'code',
    },
    {
        title: 'Comentário',
        dataIndex: 'message',
        key: 'message',
        render: (comment) => react_1.default.createElement("div", { style: { maxWidth: 450 } }, comment),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status) => {
            switch (status) {
                case 'SUBMITTED':
                    return 'Enviado';
                case 'FIXED':
                    return 'Corrigido';
                case 'APPROVED':
                    return 'Aprovado';
                case 'DONE':
                    return 'Concluído';
                case 'ARCHIVED':
                    return 'Arquivado';
                default:
                    return status;
            }
        },
    },
    {
        title: 'Data e hora',
        dataIndex: 'created',
        key: 'created',
    },
    {
        title: 'Núm. da Reserva',
        dataIndex: 'bookId',
        key: 'bookId',
        sorter: (a, b) => a.bookId + b.bookId,
        sortDirections: ['descend'],
        defaultSortOrder: 'ascend',
    },
];
const MaintenanceList = () => {
    const [dataSource, setDataSource] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [reserveInfo, setReserveInfo] = (0, react_1.useState)({
        property: {
            propId: 0,
        },
        room: {},
    });
    const formatList = (assignmentList) => {
        const formatedList = [];
        assignmentList.assigments.forEach(assignment => {
            assignment.forEach(assignmentItem => {
                formatedList.push({
                    code: `${assignmentItem.code.code} - ${assignmentItem.code.name}`,
                    message: assignmentItem.message,
                    status: assignmentItem.status,
                    created: assignmentItem.created,
                    bookId: assignmentItem.id_booking,
                });
            });
        });
        return formatedList;
    };
    (0, react_1.useEffect)(() => {
        document.title = `360 Suítes - Manutenção & Solicitações`;
    }, []);
    (0, react_1.useEffect)(() => {
        const tempReserve = localStorage.getItem('tempReserve') || '{}';
        setReserveInfo(JSON.parse(tempReserve));
    }, []);
    const getMessageError = (errorCode) => {
        const listErros = [
            {
                message: 'Nenhum pedido encontrado',
                code: -1001,
            },
            {
                message: 'Erro ao obter códigos de atribuição',
                code: -1002,
            },
            {
                message: 'Nenhuma reserva encontrada',
                code: -1006,
            },
        ];
        const findMessage = listErros.find(messagesError => messagesError.code === errorCode);
        return (findMessage === null || findMessage === void 0 ? void 0 : findMessage.message) || 'Ocorreu um erro ao carregar seus pedidos';
    };
    const fetchList = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const listAssignment = new listAssignment_1.ListAssignment(new HTTPService_1.HTTPService());
        if (!dataSource.length) {
            yield listAssignment
                .run()
                .then(tempList => {
                setDataSource(formatList(tempList));
            })
                .catch(err => {
                message_utils_1.default.error({
                    message: getMessageError(err.response.data.code),
                });
                setDataSource([]);
            });
        }
        setIsLoading(false);
    }), [dataSource.length]);
    (0, react_1.useEffect)(() => {
        fetchList();
    }, [fetchList]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = reserveInfo === null || reserveInfo === void 0 ? void 0 : reserveInfo.property) === null || _a === void 0 ? void 0 : _a.propId)
            fetchList();
    }, [fetchList, reserveInfo]);
    const scrollToStart = () => {
        const section = document.querySelector('#MaintenanceList');
        section === null || section === void 0 ? void 0 : section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    return (react_1.default.createElement("div", { id: "MaintenanceList" },
        react_1.default.createElement(ServicesWrapper_1.default, { descriptionTitle: "Su\u00EDtes" },
            react_1.default.createElement("div", { className: "list-container" },
                react_1.default.createElement(antd_1.Table, { dataSource: dataSource, columns: columns, loading: isLoading, pagination: { onChange: scrollToStart } })))));
};
exports.default = MaintenanceList;
